<div
  [formGroup]="group"
  [ngClass]="{ 'form-group--checkmark': !config.enableShowPassword && control.isValid, 'form-group--icon': config.enableShowPassword }"
>
  <input
    *ngIf="!config.emitKeyUp"
    [type]="config.passwordControl.type"
    class="form-control"
    [formControlName]="config.name"
    [attr.name]="config.name"
    [attr.placeholder]="config.placeholder"
    [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
  />
  <input
    *ngIf="config.emitKeyUp"
    [type]="config.passwordControl.type"
    class="form-control"
    [formControlName]="config.name"
    [attr.name]="config.name"
    [attr.placeholder]="config.placeholder"
    [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
    (keyup)="onKeyUp($event)"
  />
  <i
    *ngIf="config.enableShowPassword"
    class="icon"
    [ngClass]="config.passwordControl.type === formType.password ? 'icon-ui-eye-open' : 'icon-ui-eye-closed'"
    (click)="toggleShowPassword()"
    [ngStyle]="config.eyeColor && { 'background-color': '#' + config.eyeColor.color }"
  ></i>
</div>
